import { render, staticRenderFns } from "./MiraKpiTile.vue?vue&type=template&id=2693643e&scoped=true&"
import script from "./MiraKpiTile.vue?vue&type=script&lang=ts&"
export * from "./MiraKpiTile.vue?vue&type=script&lang=ts&"
import style0 from "./MiraKpiTile.vue?vue&type=style&index=0&id=2693643e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2693643e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VCard,VChip,VIcon})
